import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import React, { Component, ErrorInfo, ReactNode } from 'react';

declare const process: {
    env: {
        REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING?: string;
    };
};

const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;

export const appInsights = new ApplicationInsights({
    config: {
        connectionString,
        enableAutoRouteTracking: true
    }
});

if (connectionString) {
    appInsights.loadAppInsights();
}

export function trackException(error: unknown): void {
    if (connectionString) {
        appInsights.trackException({
            exception: error instanceof Error ? error : new Error(String(error))
        });
    }
}

export class TelemetryErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
    state = { hasError: false };

    static getDerivedStateFromError(): { hasError: boolean } {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        trackException(error);
        appInsights.trackTrace({ message: errorInfo.componentStack ?? '' });
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return <p>Something went wrong. Please refresh the page and try again.</p>;
        }

        return this.props.children;
    }
}
